import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { GridBleed as GridBleed$2 } from './Grid.style.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GridBleed = function GridBleed(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'full' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(GridBleed$2, _objectSpread(_objectSpread({
    // @ts-ignore
    $variant: variant
  }, rest), {}, {
    children: children
  }));
};
var GridBleed$1 = GridBleed;

export { GridBleed$1 as default };
//# sourceMappingURL=GridBleed.js.map
